import { alertVariants, DragAndDrop } from "@visiblethread/react-components";
import {
  ALLOWED_COLLECTIONS_EXTENSIONS,
  ALLOWED_DOCUMENTS_EXTENSIONS,
  UNSUPPORTED_DOCUMENTS_ERROR,
} from "constants/app";
import { UPLOAD_ENTITY_TYPES } from "constants/documentUploads";
import { func, string } from "prop-types";
import { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { showGlobalAlert } from "slices/app/appSlice";

import { allowedExtensionsProp } from "../propTypes";

const NOT_SUPPORTED_PREFIX = "Not supported. You can only upload file types:";

const getExtensions = (exts = []) => exts.map((ext) => `.${ext}`).join(",");

const LocalPanel = ({ allowedExtensions, onFilesSelected, target }) => {
  const dispatch = useDispatch();

  const isCollectionsTarget = target === UPLOAD_ENTITY_TYPES.COLLECTIONS;

  const extensionsAccepted = useMemo(() => {
    if (allowedExtensions?.length > 0) return allowedExtensions;

    return isCollectionsTarget
      ? ALLOWED_COLLECTIONS_EXTENSIONS
      : ALLOWED_DOCUMENTS_EXTENSIONS;
  }, [allowedExtensions, isCollectionsTarget]);

  const errorMessage = useMemo(() => {
    if (allowedExtensions?.length > 0) {
      return `${NOT_SUPPORTED_PREFIX} ${getExtensions(allowedExtensions)}`;
    }

    return isCollectionsTarget
      ? `${NOT_SUPPORTED_PREFIX} .doc,.docx,.docm,.pdf`
      : UNSUPPORTED_DOCUMENTS_ERROR;
  }, [allowedExtensions, isCollectionsTarget]);

  const handleError = useCallback(() => {
    dispatch(
      showGlobalAlert({
        variant: alertVariants.warning,
        text: errorMessage,
      })
    );
  }, [dispatch, errorMessage]);

  return (
    <div
      className="choose_files_modal__body__browser__local_panel"
      data-testid="local-panel"
    >
      <DragAndDrop
        onFilesSelected={onFilesSelected}
        acceptsMultipleFiles
        extensionsAccepted={extensionsAccepted}
        onError={handleError}
      />
    </div>
  );
};

LocalPanel.propTypes = {
  allowedExtensions: allowedExtensionsProp,
  onFilesSelected: func.isRequired,
  target: string.isRequired,
};

export default LocalPanel;
